import AOS from 'aos'

export default class RefreshAosOnResize {
    constructor() {
        const resizeObserver = new ResizeObserver(() => {
            AOS.refresh()
        })

        resizeObserver.observe(document.querySelector('body'))
    }
}
